export const AMP_DEFAULT_LOCALE = 'en-US';
export const AMP_DEFAULT_TIMEZONE = 'UTC';
export const AMP_DEFAULT_CURRENCY = 'USD';
export const AMP_PSEUDO_LOCALE_QUERY = 'pseudoLocale';
export const AMP_PSEUDO_LOCALE_STORAGE_KEY = 'amp.pseudoLocale';
